import React from 'react';
import { Button } from '@seismic/mantle';

const KeyBoardAction = {
    enter: 13
};

const DumbPrivacySettingButton = (props) => {
    const { text, onClick, useHyperLink, hilightColor, isNewUI } = props;

    const onClickPrivacySetting = (e) => {
        if (useHyperLink) {
            e.preventDefault();
        }

        if (onClick) {
            onClick(e);
        }
    };

    const onKeydown = (e) => {
        if (e.keyCode === KeyBoardAction.enter) {
            onClickPrivacySetting(e);
        }
    };

    if (useHyperLink) {
        return (
            <a
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex={0}
                className="engagement-buyer-btn-group"
                onClick={onClickPrivacySetting}
                onKeyDown={onKeydown}>
                {text}
            </a>);
    }

    if (isNewUI) {
        return (<Button
            label={text}
            onClick={onClickPrivacySetting}
            style={{ borderColor: hilightColor, backgroundColor: hilightColor }}
            variant="primary" />);
    }

    return (
        <button
            className="enagement-buyer-btn engagement-buyer-btn-group"
            onKeyDown={onKeydown}
            onClick={onClickPrivacySetting}
            style={{ borderColor: hilightColor, color: hilightColor }}>
            {text}
        </button>
    );
};

export default DumbPrivacySettingButton;
